export const QUERY_CONFIG = {
  STALE_TIME: 5 * 60 * 1000, // 5 minutes
  RETRY_COUNT: 2,
} as const;

export const QUERY_KEYS = {
  TRADING_SYSTEM_CREDENTIALS: 'tradingSystemCredentials',
} as const;

export const COPY_FEEDBACK_DURATION = 2000; // 2 seconds

export const PASSWORD_DISPLAY = {
  HIDDEN_TEXT: '•••••',
  TRUNCATE_LENGTH: 20,
  TOOLTIP_THRESHOLD: 25,
} as const;

export const SKELETON_CONFIG = {
  ROWS_COUNT: 4,
  LABEL_WIDTH: 80,
  VALUE_WIDTH: 120,
  BUTTON_HEIGHT: 48,
} as const;
